export default "__VITE_ASSET__DvhTDua2__"